import { render, staticRenderFns } from "./fileDialog.vue?vue&type=template&id=3b1234c4&scoped=true"
import script from "./fileDialog.vue?vue&type=script&lang=js"
export * from "./fileDialog.vue?vue&type=script&lang=js"
import style0 from "./fileDialog.vue?vue&type=style&index=0&id=3b1234c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1234c4",
  null
  
)

export default component.exports